import {useCallback, useEffect, useState} from "react";
import {apiGet} from "../utils";
import {buildV2QueryParams, hasDateFilters} from "../utils/filters";
import {resolveChartType} from "../config";
import {ChartPicker} from "./filters/ChartPicker";
import {KpiPanel} from "./KpiPanel";
import {BasicLineChart} from "./plotly/BasicLineChart";

export const MeasurePanel = ({filters, initialType, minimal = false, onHeaderClick, onKpiChange}) => {
    const [selectedChartType, setSelectedChartType] = useState(() => resolveChartType(initialType));
    const [kpiData, setKpiData] = useState(null);
    const [kpiDataPrevious, setKpiDataPrevious] = useState(null);
    const [chartData, setChartData] = useState([]);
    const [chartDataPrevious, setChartDataPrevious] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchChartAndKpiData = useCallback(() => {
        if (!hasDateFilters(filters)) {
            setLoading(false);
            return;
        }

        setLoading(true);
        const queryParams = buildV2QueryParams(filters);
        apiGet(`v2/calc/${selectedChartType.value}/trend${queryParams}&calc=sum`, (resp) => {
            if (resp.success) {
                const calcKey = selectedChartType.value;
                setChartData(resp.data.currentTrend.results);
                setChartDataPrevious(resp.data.priorTrend.results);
                setKpiData(resp.data.currentTrend.calcs?.[calcKey] || null);
                setKpiDataPrevious(resp.data.priorTrend.calcs?.[calcKey] || null);
            }
            setLoading(false);
        });
    }, [filters, selectedChartType]);

    useEffect(() => {
        fetchChartAndKpiData();
    }, [fetchChartAndKpiData]);

    const selectChartType = (chartTypeValue) => {
        setSelectedChartType(resolveChartType(chartTypeValue));

        if (onKpiChange) {
            onKpiChange(chartTypeValue);
        }
    };

    return (
        <div>
            {!minimal &&
                <ChartPicker chartTypeSetter={selectChartType} currentValue={selectedChartType.value}/>
            }
            {(loading || (kpiData && kpiDataPrevious)) &&
                <KpiPanel
                    chartType={selectedChartType}
                    data={kpiData}
                    dataPrevious={kpiDataPrevious}
                    showTitle={minimal}
                    onHeaderClick={onHeaderClick}
                    loading={loading}
                />
            }
            {!minimal &&
                <BasicLineChart title={selectedChartType.name} valueField={selectedChartType.value} data={chartData} previousPeriodData={chartDataPrevious}/>
            }
        </div>
    );
};
